<template lang="pug">
.b-contacts(:class="{ tile }")
  ._header
    BaseTabs2._tabs(:items="tabs" v-model="tab")
    BaseSelect._filter.-projects(:options="projectsForFilter" v-model="projectFilter" notSelectedLabel="Все проекты" label="Участники проекта")
    BaseInput._filter(label="Поиск" v-model="search")
  ._items-wrap
    ._items(v-if="$store.state.auth.user")
      template(v-if="tab === 'outcoming'")
        template(v-if="itemsFiltered.length || sentInvitations.length")
          ContactRequestTile(
            v-for="item in itemsFiltered"
            :key="item['@id']"
            :item="item.user"
            @remove="remove(item)"
          )
          ContactRequestTile(
            v-for="item in sentInvitations"
            :key="item['@id']"
            :item="item"
            @remove="removeInvitation(item)"
          )
        EmptyList._empty-list(v-else) Нет контактов
      template(v-else)
        template(v-if="itemsFiltered.length")
          ContactTile._item(
            v-for="contact in itemsFiltered"
            :key="contact['@id']"
            :item="contact"
            @invite="invite(contact)"
            @accept="accept(contact)"
            @remove="remove(contact)"
          )
        ._no-contacts(v-else)
          img(src="/img/no-contacts.png")
          Btn(lg round green @click="add()") Добавить контакт
  BasePopup(v-if="invitationsPopupOpened" @close="invitationsPopupOpened = false")
    InvitationsTile(:items="notSentInvitations" @reload="reload")
  ProjectMemberAddPopup(:projects="projects" :members="projectMembers" ref="projectMemberAddPopup")
</template>

<script>
import invitationApi from '@/api/invitation';
import projectApi from '@/api/project';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';

import BaseTabs2 from '@/components/BaseTabs2.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseInput from '@/components/BaseInput.vue';
import ContactTile from '@/components/ContactTile.vue';
import InvitationsTile from '@/components/invitation/InvitationsTile.vue';
import BasePopup from '@/components/BasePopup.vue';
import UserTile from '@/components/UserTile.vue';
import ProjectMemberAddPopup from '@/components/ProjectMemberAddPopup.vue';
import ContactRequestTile from '@/components/contact/ContactRequestTile.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

export default {
  name: 'ContactList',
  components: {
    EmptyList,
    ProjectMemberAddPopup,
    UserTile,
    BasePopup,
    InvitationsTile,
    ContactTile,
    BaseInput,
    BaseTabs2,
    CommonSection,
    DefaultLayout,
    BaseSelect,
    ContactRequestTile,
  },
  props: {
    tile: Boolean,
  },
  data() {
    return {
      tab: 'contacts',
      search: '',
      projectInvitePopup: false,
      projectToInvite: null,
      userToInvite: null,
      projectFilter: null,
      projects: [],
      invitations: [],
      invitationsPopupOpened: false,
    };
  },
  mounted() {
    this.$store.dispatch('contact/fetchItems');
    projectApi.fetchList([], true).then((r) => { this.projects = r.items; });
    invitationApi.fetchList().then((r) => { this.invitations = r.items; });

    if (this.tile) return;

    if (this.incomingItems.length) {
      this.tab = 'incoming';
    }
  },
  computed: {
    tabs() {
      return [
        { name: 'contacts', label: 'Мои контакты' },
        { name: 'incoming', label: 'Входящие заявки', count: this.incomingItems.length },
        { name: 'outcoming', label: 'Исходящие заявки', count: this.outcomingItems.length + this.sentInvitations.length },
      ];
    },
    self() { return this.$store.state.auth.user; },
    itemsRaw() {
      return this.$store.state.contact.items
        .map(c => ({
          ...c,
          user: this.self?.id === c.author.id ? c.acceptor : c.author,
        }));
    },
    contactItems() { return this.itemsRaw.filter(c => !c.isRequest); },
    incomingItems() { return this.itemsRaw.filter(c => c.isRequest && this.self.id === c.acceptor.id); },
    outcomingItems() { return this.itemsRaw.filter(c => c.isRequest && this.self.id === c.author.id); },
    sentInvitations() { return this.invitations.filter(i => i.isSent); },
    notSentInvitations() { return this.invitations.filter(i => !i.isSent); },
    itemsOfSelectedTab() {
      switch (this.tab) {
        case 'contacts': return this.contactItems;
        case 'incoming': return this.incomingItems;
        case 'outcoming': return this.outcomingItems;
        default: return [];
      }
    },
    itemsFiltered() {
      return this.itemsOfSelectedTab
        .filter(c => {
          const username = ((c.user.name ?? '') + (c.user.surname ?? '') + c.user.email).toLowerCase();
          const bySearch = !this.search || username.includes(this.search.toLowerCase().replace(/ /g, ''));
          const byProject = this.projectFilter === null || this.projectMembers[this.projectFilter].includes(c.user.id);
          return bySearch && byProject;
        });
    },
    projectsForFilter() {
      return this.projects.map((p) => ({
        value: p.id,
        label: p.name,
      }));
    },
    projectMembers() {
      return Object.fromEntries(
        this.projects.map((p) => [
          p.id,
          [p.author.id, ...p.projectMembers.map((m) => m.user.id)],
        ]),
      );
    },
  },
  methods: {
    add() {
      this.invitationsPopupOpened = true;
    },
    reload() {
      this.$store.dispatch('contact/fetchItems');
      invitationApi.fetchList().then((r) => { this.invitations = r.items; });
    },
    accept(contact) {
      this.$store.dispatch('contact/accept', contact);
    },
    remove(contact) {
      this.$store.dispatch('contact/remove', contact);
    },
    invite(contact) {
      this.$refs.projectMemberAddPopup.open(contact.user);
    },
    removeInvitation(invitation) {
      invitationApi.delete(invitation.id, true).then(() => {
        this.invitations = this.invitations.filter((i) => i.id !== invitation.id);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .contacts {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 22px;
    }

    &__tabs {
      border-bottom: 1px solid #D1D9F0;
      margin-right: auto;
    }

    &__filter {
      &--projects {
        width: 290px;
      }
    }

    &__items-wrap {
      margin-top: 30px;
    }

    &__items {
      display: grid;
      gap: 30px;
      grid-template-columns: 1fr 1fr 1fr;
      margin-bottom: 40px;
    }

    &__empty-list {
      grid-column: 1 / 3 span;
    }

    &__no-contacts {
      grid-column: 1 / 3 span;
      padding: 40px;
      width: 100%;
      border: 1px solid #EBEFF2;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        margin: 0 0 40px 150px;
      }
    }

    &.tile &__filter {
      display: none;
    }

    &.tile &__items-wrap {
      height: 100%;
      max-height: 370px;
      overflow-y: auto;
      overflow-x: hidden;
      padding-right: 15px;

      &::-webkit-scrollbar { width: 5px; }
      &::-webkit-scrollbar-track { background: #F1F1F1; }
      &::-webkit-scrollbar-thumb { background: #C1C1C1; }
    }

    &.tile &__items {
      gap: 25px;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 0;
    }

    @media (max-width: 1200px) {
      &__filter {
        display: none;
      }

      &__items {
        grid-template-columns: 1fr 1fr;
      }
    }

    @media (max-width: 1024px) {
      &.tile &__items-wrap {
        max-height: initial;
        height: auto;
        padding-right: 0;
        overflow: visible;
      }

      &.tile &__items, &__items {
        grid-template-columns: 1fr;
        gap: 1px;
      }
    }
  }
</style>
